/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function (APIFactory) {
	'use strict';

	class MetadataLoader {

		/*
			The MetadataLoader will improve performance by starting to load metadata as soon as possible in the dashboard life cycle
			The feature will also prevent hogging all network connections by leveraging a queue which only allows up to 3 metadata requests at once
		*/

		constructor(options) {
			this.options = options;
			this.API = options.features.API;
		}

		initialize() {
			const dataSources = this.API.getFeature('DataSources').getDataSourceList();
			this.loadMetadata(dataSources);
		}

		getAPI() {
			return APIFactory.createAPI(this, []);
		}

		loadMetadata(dataSources) {
			const loaderPromises = [];
			dataSources.forEach(dataSource => loaderPromises.push(dataSource.loadMetadata));
			const MAX_WORKERS = 3; //Avoid hogging all network connections by only allowing up to 3 concurrent metadata requests

			const promiseResults = [];
			var workerCount = 0;
			var promiseIdx = 0;
			return new Promise(done => {
				const getNextLoaderPromise = () => {
					if (workerCount < MAX_WORKERS && promiseIdx < loaderPromises.length) {
						loaderPromises[promiseIdx]().then(onSettlePromise).fail(onSettlePromise);
						promiseIdx++;
						workerCount++;
						getNextLoaderPromise();
					} else if (workerCount === 0 && promiseIdx === loaderPromises.length) {
						done(promiseResults);
					}
				};

				const onSettlePromise = (result) => {
					promiseResults.push(result);
					workerCount--;
					getNextLoaderPromise();
				};

				getNextLoaderPromise();
			});
		}
	}

	return MetadataLoader;
});
